export class OTIOrderLandingFilterVM {
  account: number;
  dateInDays: number;
  fromOrderDate: any;
  toOrderDate: any;
  salesOrderNumber: string;
  customerPO: string;
  orderStatus: string;
  productLineSegment: string;
  searchText: string;
  dateRangeText: string;
  orderStatusText: string;
  paginatorSize: number;
}
